import type { FC } from 'react';
import { ReactSVG } from 'react-svg';

const BASE_ICON_PATH = 'assets/icons/';

interface SVGIconI {
  id: string;
  clickHandler?: () => void;
}

export const SVGIcon: FC<SVGIconI> = ({ id, clickHandler }) => {
  return <ReactSVG src={`${BASE_ICON_PATH}${id}`} onClick={clickHandler} />;
};
